import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";


const Disclaimer = () => {
const navigate = useNavigate();
const [sticky, setSticky] = useState("");
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  const classes = `main-header ${sticky} mobhide`;
  useEffect(() => {
        // fetchcourses();
        const handleScroll = () => {
         // sticky header
    
         const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
       };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    
      }, []);
  
  return (
    <div className="main-body">
      {/* Terms & condition */}
    <section>
        <div className="termsconditionsmaindiv">
            <div className="container">
                <p className="about-head termsconditionshead">Disclaimer</p>
                <p className="terms-description">
                    Effective Date: 12th August 2025
                </p>
                <br />
                <p className="termshead">1. General Information</p>
                <p className="terms-description">The content provided on Mansthal Farming Connection is for general informational and networking purposes only. We make no representations or warranties of any kind, express or implied, regarding the accuracy, completeness, or reliability of information provided on the Platform.</p>

                <p className="termshead">2. No Professional Advice</p>
                <p className="terms-description">Farming tips, techniques, or solutions shared on the Platform are contributed by community members and do not constitute professional agricultural advice. You should seek independent verification before applying any recommendations to your farm.</p>

                <p className="termshead">3. Limitation of Liability</p>
                <p className="terms-description">Mansthal Farming Connection will not be liable for any loss, injury, or damages (including crop loss, livestock loss, or financial loss) arising directly or indirectly from the use of information available on the Platform.</p>

                <p className="termshead">4. External Links</p>
                <p className="terms-description">Our Platform may link to third-party websites or services. We are not responsible for the content, accuracy, or policies of those sites.</p>

                <p className="termshead">5. User Responsibility</p>
                <p className="terms-description">By using this Platform, you acknowledge and agree that: <br />
                a) You are solely responsible for any actions taken based on the information found here.<br />
                b) You will not hold Mansthal Farming Connection, its owners, or affiliates liable for any consequences arising from your use of the Platform.
                </p>
            </div>
        </div>
    </section>
    </div>
  );
};

export default Disclaimer;
